module.exports = __webpack_public_path__ + "static/wwf-billboard-ad878da28945050ec857506265477fc0.jpg";